import formatCurrency from "../../../../Utils/formatCurrency";

function InfUser({ user,status_active,amount_lose}) {
    return (
        <tr style={{background:status_active?"linear-gradient(#5000724d,#5a4d6a)":""}}>
            
            <th>{user.placement}</th>
            <th>{user.login}</th>
            <th>{formatCurrency(user.amount,"cost")}</th>
            {user.percent&&<th>{user.percent===100?"-":user.percent+"%"}</th>}
            {user.percent&&<th>{amount_lose>0?formatCurrency((amount_lose*user.percent/100).toFixed(2),"cost"):"-"}</th>}
            

        </tr>



    )
}
export default InfUser;